<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="$t('other.there_is_no_more')"
      @load="onLoadShopProductList"
    > 
      <van-card v-for="(item,k) in list"
				:key="k"
                num="1"
                :price="item.shop_price"
                :desc="item.shop_url"
                :title="item.shop_name"
                :thumb="item.shop_logo"
      >
        <template #tags>
          <van-tag plain type="danger">{{ $t('column.Outside_chain_goods')}}</van-tag>
        </template>
        <template #footer>
          <van-button @click="deleteShop(item.id)" size="mini">{{ $t('column.delete')}}</van-button>
        </template>
      </van-card>
    </van-list>

  </div>
</template>

<script>
    import axios from "axios";
    import Toast from "vant/lib/toast"

    export default {
        name: "shop_product_list",
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                page: 0,
                isLoading: false,
            }
        },
        created: function () {
            document.title = this.$t('title.shop_product');
        },
        methods: {
            deleteShop: function (id) {
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=myshop&act=del_shop_product" + "&time=" + new Date().getTime(),
                    {
                        params: {
                            token: token,
                            id: id,
                        }
                    }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        return;
                    }
                    window.location.reload();
                    Toast(this.$t('column.Deletion_succeeded'));
                });
            },
            onLoadShopProductList: function () {
                this.page++;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=myshop&act=get_shop_product_list", {
                    params: {
                        token: token,
                        page: this.page,
                        start_time: this.gift_start_time,
                        end_time: this.gift_end_time,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        this.finished = true;
                        return;
                    }
                    if (this.page === 1) {
                        this.list = res.data.list;
                    } else {
                        this.list = this.list.concat(res.data.list)
                    }

                    // 加载状态结束
                    this.loading = false;

                    //数据全部加载完成
                    if (res.data.list.length < 50) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }

                    this.isLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shop_product_list.vue